import React from 'react';
import styles from '../LandingPage.module.css';
import extraStyles from '../LandingPageExtras.module.css';

const EngineeringBanner = () => {
  return (
    <div className={styles.lightSection}>
      <div className={extraStyles.engineeringBanner}>
        {/* We would put a background image here */}
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'url("https://via.placeholder.com/1280x400") center/cover no-repeat', opacity: 0.8, filter: 'hue-rotate(180deg)' }}></div>
        
        <div className={extraStyles.engineeringBannerContent}>
          <div className={styles.pillLight} style={{ background: 'transparent', border: 'none', padding: 0, color: '#3b82f6', fontWeight: 600, letterSpacing: '1px', fontSize: '0.75rem', textTransform: 'uppercase' }}>
            🔹 Inside a Provaantech GCC
          </div>
          <h2>Engineering teams that ship AI products at enterprise scale.</h2>
          <p>Hybrid pods of platform engineers, AI specialists and QA leaders — operating 24/7 from India to power your global business.</p>
        </div>
      </div>
    </div>
  );
};

export default EngineeringBanner;
